import { EDescriptionTextItemType } from '@shared/common/data/products';

export const descriptionData = [
  {
    imgSrc: 'assets/images/index_description_image1.jpg',
    text: [
      {
        type: EDescriptionTextItemType.caption,
        text: /* html */ `<span style="font-family: ZenMaruGothic">伝えたい思いを込めて</span>`,
      },
      {
        type: EDescriptionTextItemType.regular,
        text: 'お子さんのお名前や写真、伝えたいメッセージを込めた一生の思い出になる絵本がつくれます。',
      },
    ],
  },
  {
    imgSrc: 'assets/images/index_description_image2.jpg',
    text: [
      {
        type: EDescriptionTextItemType.caption,
        text: /* html */ `<span style="font-family: ZenMaruGothic">専用のパッケージでお届け</span>`,
      },
      {
        type: EDescriptionTextItemType.regular,

        text: `最短4日で専用のパッケージに入れてお届けします。<br><br>お孫さんのお誕生日に、特別な日の記念に、特別な思い出の贈り物にも最適です。`,
      },
    ],
  },
];

export const descriptionDataAlphabetTrain = [
  {
    imgSrc: 'assets/images/image01AT.jpg',
    text: [
      {
        type: EDescriptionTextItemType.caption,
        text: /* html */ `<span style="font-family: ZenMaruGothic">自分の名前の文字を探して大冒険！</span>`,
      },
      {
        type: EDescriptionTextItemType.regular,
        text: '絵本のなかに隠された自分の名前の文字を探しながら冒険する絵本です。<br><br>名前の文字以外にも探し絵要素が盛りだくさん！',
      },
    ],
  },
  {
    imgSrc: 'assets/images/image02AT.jpg',
    text: [
      {
        type: EDescriptionTextItemType.caption,
        text: /* html */ `<span style="font-family: ZenMaruGothic">名前に込めた思いを伝える</span>`,
      },
      {
        type: EDescriptionTextItemType.regular,

        text: `お子さんやお孫さんの名前に込めた思いを伝えることができます。<br><br>特別な記念の日などに最適な1冊です。`,
      },
    ],
  },
  {
    imgSrc: 'assets/images/image03AT.jpg',
    text: [
      {
        type: EDescriptionTextItemType.caption,
        text: /* html */ `<span style="font-family: ZenMaruGothic">ギフトにも最適！</span>`,
      },
      {
        type: EDescriptionTextItemType.regular,

        text: `お届け用の専用パッケージは、組み立てると絵本を飾る棚にもなります。<br><br>好きな色を塗って、自分専用の絵本棚に。`,
      },
    ],
  },
];
export const descriptionDataMainichiKinenbi = [
  {
    imgSrc: 'assets/images/image01MK.jpg',
    text: [
      {
        type: EDescriptionTextItemType.caption,
        text: /* html */ `<span style="font-family: ZenMaruGothic">1 年間の成長を形に残そう</span>`,
      },
      {
        type: EDescriptionTextItemType.regular,
        text: 'この 1 年で、どんなことがあったかな？<br><br>なにができるようになった？<br><br>できごとを振り返りながら、記念日を 1 冊にまとめることができます。',
      },
    ],
  },
  {
    imgSrc: 'assets/images/image02MK.jpg',
    text: [
      {
        type: EDescriptionTextItemType.caption,
        text: /* html */ `<span style="font-family: ZenMaruGothic">家族のアルバムとして定期的に作成！</span>`,
      },
      {
        type: EDescriptionTextItemType.regular,

        text: `家族と暮らすまいにちで起きたできごと、なんでも魔法で記念日になる！<br><br>絵本をみんなで作った時間さえも、忘れられない 1 コマに。`,
      },
    ],
  },
  {
    imgSrc: 'assets/images/image03MK.jpg',
    text: [
      {
        type: EDescriptionTextItemType.caption,
        text: /* html */ `<span style="font-family: ZenMaruGothic">おじいちゃん、おばあちゃんにプレゼント</span>`,
      },
      {
        type: EDescriptionTextItemType.regular,

        text: `会えない間にあったあんなことやこんなこと、教えてあげたい！<br><br>絵本の中でなら、いつでもどこでも思い出を共有できるはず。`,
      },
    ],
  },
  {
    imgSrc: 'assets/images/image04MK.jpg',
    text: [
      {
        type: EDescriptionTextItemType.caption,
        text: /* html */ `<span style="font-family: ZenMaruGothic">推し活記録に使うのも◎！</span>`,
      },
      {
        type: EDescriptionTextItemType.regular,

        text: `大好きなひと、ものとの思い出を記録していくのにもぴったり！<br><br>行った場所や買ったもの…。<br><br>ページが増えていくたびにうれしくなっちゃう。`,
      },
    ],
  },
  {
    imgSrc: 'assets/images/image05MK.jpg',
    text: [
      {
        type: EDescriptionTextItemType.caption,
        text: /* html */ `<span style="font-family: ZenMaruGothic">ペットと過ごす日々も記念日に</span>`,
      },
      {
        type: EDescriptionTextItemType.regular,

        text: `一緒に大きく成長していく、たいせつなペットとの思い出にも魔法をかけてみよう。<br><br>絵本の形だから、本棚から取り出していつでも見返せる！`,
      },
    ],
  },
];

export const descriptionDataAnpanmanBirthday = [
  {
    imgSrc: 'assets/images/image01.jpg',
    text: [
      {
        type: EDescriptionTextItemType.caption,
        text: /* html */ `<span style="font-family: ZenMaruGothic">伝えたい思いを込めて</span>`,
      },
      {
        type: EDescriptionTextItemType.regular,
        text: 'お子さまに伝えたいメッセージを入れ、何度でも読み返したくなります。',
      },
    ],
  },
  {
    imgSrc: 'assets/images/image02.jpg',
    text: [
      {
        type: EDescriptionTextItemType.caption,
        text: /* html */ `<span style="font-family: ZenMaruGothic">好きな写真を選んで絵本に</span>`,
      },
      {
        type: EDescriptionTextItemType.regular,

        text: `お子さまの写真、家族との写真、お子さまが描いた絵を写真で撮ったものなど、思い出として残すことができます。`,
      },
    ],
  },
  {
    imgSrc: 'assets/images/image03.jpg',
    text: [
      {
        type: EDescriptionTextItemType.caption,
        text: /* html */ `<span style="font-family: ZenMaruGothic">最短4日でお届け</span>`,
      },
      {
        type: EDescriptionTextItemType.regular,
        text: '配送は宅急便、またはメール便（ポスト投函、日時指定不可）で、ご自宅までお届けします。発送時にメールでご案内いたします。',
      },
    ],
  },
  {
    imgSrc: 'assets/images/image04.jpg',
    text: [
      {
        type: EDescriptionTextItemType.caption,
        text: /* html */ `<span style="font-family: ZenMaruGothic">ギフトにも！</span>`,
      },
      {
        type: EDescriptionTextItemType.regular,
        text: 'お孫さんのお誕生日に、お友だちのお子さまへのお祝いに、特別な思い出の贈り物になります。',
      },
    ],
  },
];
